import { replacePlaceholders } from '@/features/data-hub/lib/replacePlaceholders';

import { transformSymbols } from './transformSymbols';

import type { BuildScriptInput, ScriptBuilder } from './ScriptBuilder';

export const defaultScriptBuilder: ScriptBuilder = {
  build({
    template,
    symbols,
    rangeStart,
    rangeEnd,
    timezone,
    withMetadata,
    apiKey,
    defaultGroupName
  }: BuildScriptInput): string {
    const payload = transformSymbols(symbols, defaultGroupName);

    const replacements = {
      symbols: JSON.stringify(payload.symbols, undefined, 4),
      rangeStart,
      rangeEnd,
      timezone,
      withMetadata: withMetadata.toString(),
      apiKey
    } as const;

    return replacePlaceholders(template, replacements);
  }
};
